export default function () {
    $('input[type="file"]').on('change', function () {
        let value = $(this)[0].files[0] ? $(this)[0].files[0].name : '';
        if (value) {
            $('.js-file-value').text(value);
        } else {
            $('.js-file-value').text('Резюме в PDF/DOC/DOCX');
        }
    });
}